export default __webpack_public_path__ + "static/media/preview-close-one.ea121253.svg";